import script from "./ModalFilterCampaignDistributionPcs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalFilterCampaignDistributionPcs.vue?vue&type=script&setup=true&lang=ts"

import "./ModalFilterCampaignDistributionPcs.vue?vue&type=style&index=0&id=258a05af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258a05af"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QInput,QSelect,QBtn,QIcon});
